import { Component, OnInit,Input, Output,EventEmitter } from '@angular/core';

@Component({
  selector: 'app-gestiones-politicas',
  templateUrl: './gestiones-politicas.component.html',
  styleUrls: ['./gestiones-politicas.component.scss']
})
export class GestionesPoliticasComponent implements OnInit {
  @Output() selecttab = new EventEmitter<number>();
  @Output() selectParticipante = new EventEmitter<number>();
  @Input() gestionSeleccionada: any
  //@Input() politicas: any
  @Input() participante: any
  @Input() set politicas(value: any) {
    this._politicas = value
    this.gestionSeleccionada.version = this.gestionSeleccionada.ofertaComercialSeleccionada.VersionDePolitica
    if (this.gestionSeleccionada.version && this.gestionSeleccionada.version != "V2") {
      this.generateFlujoEvaluacion(this._politicas)
    } else {
      this.divisionPolitica(this._politicas)
      // this.sortPoliticas(this._politicas)
    }
 }
  public _politicas
  listflujo=[]
  listflujoV2=[]
  constructor() { }

  ngOnInit(): void {
  }
  selectedtab(tab) {
    this.selecttab.emit(tab)
  }
  selectedparticipante(item) {
    this.selectParticipante.emit(item)
  }
  divisionPolitica(politicas){
    let postfijo;
    this.participante == 0  ? postfijo = 'Deudor' : postfijo = 'Codeudor';
    politicas.forEach(element => {
    if(element.reglaParticipante===postfijo){
      this.listflujoV2.push(element);
    }
  });
  console.log(this.listflujoV2)
  this.sortPoliticas(this.listflujoV2)
  }
  sortPoliticas(politicas) {
    this.listflujoV2=politicas.sort((a,b)=>a.reglaJerarquia-b.reglaJerarquia)
    console.log(this.listflujoV2)
  }
  generateFlujoEvaluacion(politicas) {
    this.listflujo = [];
    politicas.forEach(element => {
      const aux = element.codigoDecision.split('_');
      let prefijo;
      aux[0] === 'PA'
        ? prefijo = 'PA' : aux[0] === 'E'
          ? prefijo = 'PA' : aux[0] === 'P'
            ? prefijo = 'PA' :  aux[0] === 'PB'
              ? prefijo = 'PA' : aux[0] === 'PC'
                ? prefijo = 'PA' : aux[0] === 'EA+'
                  ? prefijo = 'PA' : aux[0] === 'EA'
                    ? prefijo = 'PA' : aux[0] === 'EB'
                      ? prefijo = 'PA' : aux[0] === 'EC'
                        ? prefijo = 'PA' :  aux[0] === 'PV'
                          ? prefijo = 'PVA' : aux[0] === 'PVA'
                            ? prefijo = 'PVA' : aux[0] === 'PVI'
                              ? prefijo = 'PVA' : prefijo = 'PVA';
      element.codigoDecision = prefijo + '_' + aux[1];
      let postfijo;
      this.participante == 0  ? postfijo = '_D' : postfijo = '_C';
      if (element.codigoDecision === 'PA' + postfijo + '004'
        || element.codigoDecision  === 'PVA'  + postfijo + '004') { // edad minima y maxima
        if (element.decision === 'APROBADO') {
          this.listflujo.push({ codigo: 1, tipo: 'A', nombre: 'EDAD MINIMA'});
          this.listflujo.push({ codigo: 2, tipo: 'A', nombre: 'EDAD MAXIMA' });
        } else if (element.decision === 'RECHAZAR') {
          if (element.nombrePolitica === 'EDAD MINIMA') {
            this.listflujo.push({ codigo: 1, tipo: 'R', nombre: 'EDAD MINIMA' });
            this.listflujo.push({ codigo: 2, tipo: 'A', nombre: 'EDAD MAXIMA' });
          } else {
            this.listflujo.push({ codigo: 1, tipo: 'A', nombre: 'EDAD MINIMA' });
            this.listflujo.push({ codigo: 2, tipo: 'R', nombre: 'EDAD MAXIMA' });
          }
        }
      } else if (element.codigoDecision === 'PA' + postfijo + '005'
          || element.codigoDecision === 'PVA' + postfijo + '005') { // estabilidad laboral
        if (element.decision === 'APROBADO') {
          this.listflujo.push({ codigo: 3, tipo: 'A', nombre: 'ESTABILIDAD LABORAL' });
        } else {
          this.listflujo.push({ codigo: 3, tipo: 'R', nombre: 'ESTABILIDAD LABORAL' });
        }
      } else if (element.codigoDecision === 'PA' + postfijo + '007'
        || element.codigoDecision === 'PVA' + postfijo + '007') { // salario minimo
        if (element.decision === 'APROBADO') {
          this.listflujo.push({ codigo: 4, tipo: 'A', nombre: 'SALARIO MINIMO' });
        } else {
          this.listflujo.push({ codigo: 4, tipo: 'R', nombre: 'SALARIO MINIMO' });
        }
      } else if (element.codigoDecision === 'PA' + postfijo + '006'
        || element.codigoDecision === 'PVA' + postfijo + '006') { // monto minimo
        if (element.decision === 'APROBADO') {
          this.listflujo.push({ codigo: 5, tipo: 'A', nombre: 'MONTO MINIMO' });
        } else {
          this.listflujo.push({ codigo: 5, tipo: 'R', nombre: 'MONTO MINIMO' });
        }
      } else if (element.codigoDecision === 'PA' + postfijo + '008'
        || element.codigoDecision === 'PVA' + postfijo + '008') { // monto maximo
        if (element.decision === 'APROBADO') {
          this.listflujo.push({ codigo: 6, tipo: 'A', nombre: 'MONTO MAXIMO' });
        } else {
          this.listflujo.push({ codigo: 6, tipo: 'R', nombre: 'MONTO MAXIMO' });
        }
      } else if (element.codigoDecision === 'PA' + postfijo + '010'
        || element.codigoDecision === 'PVA' + postfijo + '010') { // plazo minimo y maximo
        if (element.decision === 'APROBADO') {
          this.listflujo.push({ codigo: 7, tipo: 'A', nombre: 'PLAZO MINIMO' });
          this.listflujo.push({ codigo: 8, tipo: 'A', nombre: 'PLAZO MAXIMO' });
        } else if (element.decision === 'RECHAZAR') {
          if (element.nombrePolitica === 'PLAZO MAXIMO') {
            this.listflujo.push({ codigo: 7, tipo: 'A', nombre: 'PLAZO MINIMO' });
            this.listflujo.push({ codigo: 8, tipo: 'R', nombre: 'PLAZO MAXIMO' });
          } else {
            this.listflujo.push({ codigo: 7, tipo: 'R', nombre: 'PLAZO MINIMO' });
            this.listflujo.push({ codigo: 8, tipo: 'A', nombre: 'PLAZO MAXIMO' });
          }
        }
      } else if (element.codigoDecision === 'PA' + postfijo + '013'
        || element.codigoDecision === 'PVA' + postfijo + '013') { // Buro SIRC: SIRC ACTUAL
        if (element.decision === 'APROBADO') {
          this.listflujo.push({ codigo: 9, tipo: 'A', nombre: 'SIRC ACTUAL' });
        } else {
          this.listflujo.push({ codigo: 9, tipo: 'R', nombre: 'SIRC ACTUAL' });
        }
      } else if (element.codigoDecision === 'PA' + postfijo + '011'
        || element.codigoDecision === 'PVA' + postfijo + '011') { // cancelacion contra reserva
        if (element.decision === 'APROBADO') {
          this.listflujo.push({ codigo: 10, tipo: 'A', nombre: 'CANCELACIONES CONTRA RESERVA' });
        } else if (element.decision === 'SIN DECISION') {
          this.listflujo.push({ codigo: 10, tipo: 'SD', nombre: 'CANCELACIONES CONTRA RESERVA'});
        } else {
          this.listflujo.push({ codigo: 10, tipo: 'R', nombre: 'CANCELACIONES CONTRA RESERVA' });
        } // ----- solo privado
      } else if (element.codigoDecision === 'PA' + postfijo + '019') { // CANTIDAD DE CREDITOS VIGENTES
        if (element.decision === 'APROBADO') {
          this.listflujo.push({ codigo: 11, tipo: 'A', nombre: 'CANTIDAD DE CREDITOS VIGENTES' });
        } else {
          this.listflujo.push({ codigo: 11, tipo: 'R', nombre: 'CANTIDAD DE CREDITOS VIGENTES' });
        }
      } else if (element.codigoDecision === 'PA' + postfijo + '017') { // DIAS MORA
        if (element.decision === 'APROBADO') {
          this.listflujo.push({ codigo: 12, tipo: 'A', nombre: 'MORA INTERNA' });
        } else {
          this.listflujo.push({ codigo: 12, tipo: 'R', nombre: 'MORA INTERNA' });
        }
      } else if (element.codigoDecision === 'PA' + postfijo + '015') { // LAPSO EXPOSICION
        if (element.decision === 'APROBADO') {
          this.listflujo.push({ codigo: 13, tipo: 'A', nombre: 'INCREMENTO EXPOSICION TARJETA DE CREDITO' });
        } else {
          this.listflujo.push({ codigo: 13, tipo: 'R', nombre: 'INCREMENTO EXPOSICION TARJETA DE CREDITO' });
        }
      } else if (element.codigoDecision === 'PA' + postfijo + '016') { // LAPSO EXPOSICION
        if (element.decision === 'APROBADO') {
          this.listflujo.push({ codigo: 14, tipo: 'A', nombre: 'INCREMENTO EXPOSICION CREDITO' });
        } else {
          this.listflujo.push({ codigo: 14, tipo: 'R', nombre: 'INCREMENTO EXPOSICION CREDITO' });
        }
      } else if (element.codigoDecision === 'PA' + postfijo + '014') { // LISTAS DE SEGUIMIENTO PRIVADO
        if (element.decision === 'APROBADO') {
          this.listflujo.push({ codigo: 15, tipo: 'A', nombre: 'LISTAS DE SEGUIMIENTO' });
        } else if (element.decision === 'SIN DECISION') {
          this.listflujo.push({ codigo: 15, tipo: 'SD', nombre: 'LISTAS DE SEGUIMIENTO'});
        } else {
          this.listflujo.push({ codigo: 15, tipo: 'R', nombre: 'LISTAS DE SEGUIMIENTO' });
        }
      } else if (element.codigoDecision === 'PA' + postfijo + '002') { // RCI INTERNO FINAL privado
        if (element.decision === 'APROBADO') {
          this.listflujo.push({ codigo: 16, tipo: 'A', nombre: 'RCI INTERNO FINAL' });
        } else {
          this.listflujo.push({ codigo: 16, tipo: 'R', nombre: 'RCI INTERNO FINAL' });
        }
      } else if (element.codigoDecision === 'PA' + postfijo + '001') { // RCI global privado
        if (element.decision === 'APROBADO') {
          this.listflujo.push({ codigo: 17, tipo: 'A', nombre: 'RCI GLOBAL FINAL' });
        } else {
          this.listflujo.push({ codigo: 17, tipo: 'R', nombre: 'RCI GLOBAL FINAL' });
        }
      } else if (element.codigoDecision === 'PA' + postfijo + '003') { // LIQUIDEZ MINIMA privado
        if (element.decision === 'APROBADO') {
          this.listflujo.push({ codigo: 18, tipo: 'A', nombre: 'LIQUIDEZ MINIMA' });
        } else {
          this.listflujo.push({ codigo: 18, tipo: 'R', nombre: 'LIQUIDEZ MINIMA' });
        }
      } else if (element.codigoDecision === 'PA' + postfijo + '100') { // LIQUIDEZ MAXIMA privado
        if (element.decision === 'APROBADO') {
          this.listflujo.push({ codigo: 19, tipo: 'A', nombre: 'LIQUIDEZ MAXIMA' });
        } else {
          this.listflujo.push({ codigo: 19, tipo: 'R', nombre: 'LIQUIDEZ MAXIMA' });
        }
      } else if (element.codigoDecision === 'PA' + postfijo + '009') { // EXPOSICION MAXIMA privado
        if (element.decision === 'APROBADO') {
          this.listflujo.push({ codigo: 20, tipo: 'A', nombre: 'EXPOSICION MAXIMA' });
        } else {
          this.listflujo.push({ codigo: 20, tipo: 'R', nombre: 'EXPOSICION MAXIMA' });
        }
      } else if (element.codigoDecision === 'PA' + postfijo + '018') { // EXPOSICION MAXIMA TOTAL privado
        if (element.decision === 'APROBADO') {
          this.listflujo.push({ codigo: 21, tipo: 'A', nombre: 'EXPOSICION MAXIMA TOTAL' });
        } else {
          this.listflujo.push({ codigo: 21, tipo: 'R', nombre: 'EXPOSICION MAXIMA TOTAL' });
        }
      } else if (element.codigoDecision === 'PA' + postfijo + '099') { // MARGEN FINANCIERO
        if (element.decision === 'APROBADO') {
          this.listflujo.push({ codigo: 22, tipo: 'A', nombre: 'MARGEN FINANCIERO' });
        } else {
          this.listflujo.push({ codigo: 22, tipo: 'R', nombre: 'MARGEN FINANCIERO' });
        }
      } else if (element.codigoDecision === 'PA' + postfijo + '012' && postfijo === '_D') {
        if (element.decision === 'APROBADO') {
          this.listflujo.push({ codigo: 23, tipo: 'A', nombre: 'SOLICITA CODEUDOR' });
        } else {
          this.listflujo.push({ codigo: 23, tipo: 'R', nombre: 'SOLICITA CODEUDOR' });
        } // ------solo pago voluntario
      } else if (element.codigoDecision === 'PA' + postfijo + '012' && postfijo === '_C') {
        if (element.decision === 'APROBADO') {
          this.listflujo.push({ codigo: 23, tipo: 'A', nombre: 'SCORE CODEUDOR' });
        } else {
          this.listflujo.push({ codigo: 23, tipo: 'R', nombre: 'SCORE CODEUDOR' });
        } // ------solo pago voluntario
      } else if (element.codigoDecision === 'PVA' + postfijo + '014') {//CONTEO DE MORA 90+
        if (element.decision == 'APROBADO') {
          if (element.descripcionDecision == 'CONTEO DE MORA 90') {
            this.listflujo.push({ codigo: 11, tipo: 'A',nombre:'CONTEO DE MORA 90+' })
          }
          else {
            this.listflujo.push({ codigo: 12, tipo: 'A',nombre:'CONTEO DE MORA 120+' })
          }
        }
        else {
          if (element.descripcionDecision == 'CONTEO DE MORA 90') {
            this.listflujo.push({ codigo: 11, tipo: 'R',nombre:'CONTEO DE MORA 90+' })
          }
          else {
            this.listflujo.push({ codigo: 12, tipo: 'R',nombre:'CONTEO DE MORA 120+' })
          }
        }
      }
      else if (element.codigoDecision == 'PVA'+postfijo+'015') {//CONTEO DE MORA 60+
        if (element.decision == 'APROBADO') {
          this.listflujo.push({ codigo: 13, tipo: 'A',nombre:'CONTEO DE MORAS 60+' })
        }
        else {
          this.listflujo.push({ codigo: 13, tipo: 'R',nombre:'CONTEO DE MORAS 60+' })
        }
      }
      else if (element.codigoDecision == 'PVA'+postfijo+'023') {//EXPERIENCIA CREDITICIA
        if (element.decision == 'APROBADO') {
          this.listflujo.push({ codigo: 14, tipo: 'A',nombre:'EXPERIENCIA CREDITICIA' })
        }
        else {
          this.listflujo.push({ codigo: 14, tipo: 'R',nombre:'EXPERIENCIA CREDITICIA' })
        }
      }
      else if (element.codigoDecision == 'PVA'+postfijo+'021') {//INCREMENTO EXPOSICION
        if (element.decision == 'APROBADO') {
          this.listflujo.push({ codigo: 15, tipo: 'A',nombre:'INCREMENTO EXPOSICION' })
        }
        else {
          this.listflujo.push({ codigo: 15, tipo: 'R',nombre:'INCREMENTO EXPOSICION' })
        }
      }
      else if (element.codigoDecision == 'PVA'+postfijo+'019') {//CANTIDAD DE CREDITOS VIGENTES
        if (element.decision == 'APROBADO') {
          this.listflujo.push({ codigo: 16, tipo: 'A',nombre:'CANTIDAD DE CREDITOS VIGENTES' })
        }
        else {
          this.listflujo.push({ codigo: 16, tipo: 'R',nombre:'CANTIDAD DE CREDITOS VIGENTES' })
        }
      }
      else if (element.codigoDecision == 'PVA'+postfijo+'018') {//INCREMENTO EXPOSICION TARJETA DE CRÉDITO
        if (element.decision == 'APROBADO') {
          this.listflujo.push({ codigo: 17, tipo: 'A',nombre:'INCREMENTO EXPOSICION TARJETA DE CRÉDITO' })
        }
        else {
          this.listflujo.push({ codigo: 17, tipo: 'R',nombre:'INCREMENTO EXPOSICION TARJETA DE CRÉDITO' })
        }
      }
      else if (element.codigoDecision == 'PVA'+postfijo+'016') {//LISTAS DE SEGUIMIENTO
        if (element.decision == 'APROBADO') {
          this.listflujo.push({ codigo: 18, tipo: 'A',nombre:'LISTAS DE SEGUIMIENTO' })
        }
        else if (element.decision == 'SIN DECISION') {
          this.listflujo.push({ codigo: 18, tipo: 'SD',nombre:'LISTAS DE SEGUIMIENTO'})
        }
        else {
          this.listflujo.push({ codigo: 18, tipo: 'R',nombre:'LISTAS DE SEGUIMIENTO' })
        }
      }
      else if (element.codigoDecision == 'PVA'+postfijo+'002') {//RCI INTERNO FINAL
        if (element.decision == 'APROBADO') {
          this.listflujo.push({ codigo: 19, tipo: 'A',nombre:'RCI GLOBAL FINAL' })
        }
        else {
          this.listflujo.push({ codigo: 19, tipo: 'R',nombre:'RCI GLOBAL FINAL' })
        }
      }
      else if (element.codigoDecision == 'PVA'+postfijo+'001') {//RCI GLOBAL FINAL
        if (element.decision == 'APROBADO') {
          this.listflujo.push({ codigo: 20, tipo: 'A',nombre:'RCI GLOBAL FINAL' })
        }
        else {
          this.listflujo.push({ codigo: 20, tipo: 'R',nombre:'RCI GLOBAL FINAL' })
        }
      }
      else if (element.codigoDecision == 'PVA'+postfijo+'003') {//LIQUIDEZ MINIMA
        if (element.decision == 'APROBADO') {
          this.listflujo.push({ codigo: 21, tipo: 'A',nombre:'LIQUIDEZ MINIMA' })
        }
        else {
          this.listflujo.push({ codigo: 21, tipo: 'R',nombre:'LIQUIDEZ MINIMA' })
        }
      }
      else if (element.codigoDecision == 'PVA'+postfijo+'100') {//LIQUIDEZ MAXIMA
        if (element.decision == 'APROBADO') {
          this.listflujo.push({ codigo: 22, tipo: 'A',nombre:'LIQUIDEZ MAXIMA' })
        }
        else {
          this.listflujo.push({ codigo: 22, tipo: 'R',nombre:'LIQUIDEZ MAXIMA' })
        }
      }
      else if (element.codigoDecision == 'PVA'+postfijo+'009') {//EXPOSICION MAXIMA
        if (element.decision == 'APROBADO') {
          this.listflujo.push({ codigo: 23, tipo: 'A',nombre:'EXPOSICION MAXIMA' })
        }
        else {
          this.listflujo.push({ codigo: 23, tipo: 'R',nombre:'EXPOSICION MAXIMA' })
        }
      }
      else if (element.codigoDecision == 'PVA'+postfijo+'020') {//EXPOSICION MAXIMA TOTAL
        if (element.decision == 'APROBADO') {
          this.listflujo.push({ codigo: 24, tipo: 'A',nombre:'EXPOSICION MAXIMA TOTAL' })
        }
        else {
          this.listflujo.push({ codigo: 24, tipo: 'R',nombre:'EXPOSICION MAXIMA TOTAL' })
        }
      }
    });
    setTimeout(() => {
      this.listflujo = this.listflujo.sort((a, b) => (a.codigo > b.codigo) ? 1 : -1)
    }, 200);
  }
}
